import { useEffect, useState } from "react";
import { Sidebar } from "./sidebar";

const Header = () => {
  const RoleName = localStorage.getItem('role_type') || "Unknown User"
    ?.replace(/[-._^]/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());

  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen((prev) => !prev);

  useEffect(() => {
    if (isModalOpen) {
      document.body.classList.add("toggle-slide");
    } else {
      document.body.classList.remove("toggle-slide");
    }
    return () => {
      document.body.classList.remove("toggle-slide");
    };
  }, [isModalOpen]);

  return (
    <>
      <header className="header-bar flex items-center p-4 bg-white dark:bg-gray-800 shadow-md ml-64 relative z-[1] duration-300">
        <button onClick={openModal} type="button" className="text-2xl text-slate-700 dark:text-slate-50">
          <i className="ri-menu-line"></i>
        </button>

        <div className="ml-auto">
          <div className="flex flex-row items-center gap-2 bg-gray-100 dark:bg-gray-700 border-2 border-gray-300 dark:border-gray-500 rounded-lg px-4 py-1.5 shadow-sm">
            <div className="w-6 h-6 rounded-full bg-gray-400 dark:bg-gray-500 flex items-center justify-center">
              <i className="ri-user-fill text-white text-xs"></i>
            </div>
            <span className="text-xs font-semibold tracking-wide text-gray-600 dark:text-gray-300 whitespace-nowrap">
              {RoleName}
            </span>
          </div>
        </div>
      </header>
      <Sidebar onLogout={function (): void {
        throw new Error("Function not implemented.");
      }} />
    </>
  );
};

export default Header;